import React from 'react';
import './TaskStats.css';

const TaskStats = ({ stats }) => {
  const {
    totalTasks = 0,
    completedTasks = 0,
    pendingTasks = 0,
    inProgressTasks = 0,
    overdueTasks = 0
  } = stats;

  const completionRate = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

  const statCards = [
    {
      title: 'Total Tasks',
      value: totalTasks,
      icon: 'fas fa-tasks',
      color: '#64b5f6',
      bgColor: 'rgba(100, 181, 246, 0.1)'
    },
    {
      title: 'Completed',
      value: completedTasks,
      icon: 'fas fa-check-circle',
      color: '#81c784',
      bgColor: 'rgba(129, 199, 132, 0.1)'
    },
    {
      title: 'In Progress',
      value: inProgressTasks,
      icon: 'fas fa-spinner',
      color: '#ffb74d',
      bgColor: 'rgba(255, 183, 77, 0.1)'
    },
    {
      title: 'Pending',
      value: pendingTasks,
      icon: 'fas fa-clock',
      color: '#ba68c8',
      bgColor: 'rgba(186, 104, 200, 0.1)'
    },
    {
      title: 'Overdue',
      value: overdueTasks,
      icon: 'fas fa-exclamation-triangle',
      color: '#e57373',
      bgColor: 'rgba(229, 115, 115, 0.1)'
    },
    {
      title: 'Completion Rate',
      value: `${completionRate}%`,
      icon: 'fas fa-chart-line',
      color: '#4fc3f7',
      bgColor: 'rgba(79, 195, 247, 0.1)'
    }
  ];

  return (
    <div className="task-stats">
      <div className="stats-grid">
        {statCards.map((stat, index) => (
          <div 
            key={index} 
            className="stat-card"
            style={{ backgroundColor: stat.bgColor }}
          >
            <div className="stat-icon" style={{ color: stat.color }}>
              <i className={stat.icon}></i>
            </div>
            <div className="stat-content">
              <h3 className="stat-value">{stat.value}</h3>
              <p className="stat-title">{stat.title}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Progress bar for completion rate */}
      <div className="completion-meter">
        <div className="meter-header">
          <h4>Overall Progress</h4>
          <span>{completionRate}%</span>
        </div>
        <div className="meter-bar">
          <div 
            className="meter-fill" 
            style={{ width: `${completionRate}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default TaskStats;